import { render, staticRenderFns } from "./subjectRecordsTable.vue?vue&type=template&id=4b884261&"
import script from "./subjectRecordsTable.vue?vue&type=script&lang=ts&"
export * from "./subjectRecordsTable.vue?vue&type=script&lang=ts&"
import style0 from "./subjectRecordsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports